import moment from "moment";
import "moment/locale/es";
import dineroDisabledMask from "../Components/dineroDisabledMask";

const cantidad4 = (valor) => String(Math.round((Number(valor) || 0) * 10000) / 10000);

moment.locale("es");

const nombreCompleto = (persona) =>
  persona ? [persona.nombre, persona.apellidoPaterno, persona.apellidoMaterno].filter(Boolean).join(" ") || "—" : "—";

const nombreInsumo = (insumo) => {
  if (!insumo || typeof insumo !== "object") return "—";
  return `${insumo.clave ? insumo.clave + " - " : ""}${insumo.descripcion || "—"}`;
};

const ordenProduccionCierrePdf = (values) => {
  const empresa = values.empresa || {};
  const orden = values.orden || {};
  const lotes = values.lotes || [];
  const movimientos = values.movimientos || [];

  const filasLotes = lotes.map((lote) => [
    { text: lote.folio, style: "textoTabla" },
    { text: lote.cantidadPiezas?.toString() || "0", style: "textoTabla", alignment: "right" },
    { text: lote.etapaActualId?.nombre || "—", style: "textoTabla" },
    { text: dineroDisabledMask(lote.costoUnitarioAcumulado || 0), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(lote.costoTotal || 0), style: "textoTabla", alignment: "right" },
    { text: (lote.vecesRetrabajado || 0).toString(), style: "textoTabla", alignment: "center" },
    { text: lote.estado === 3 ? "Cerrado" : lote.estado === 2 ? "Dividido" : "Activo", style: "textoTabla", alignment: "center" },
  ]);

  const filasComparativo = [];
  (orden.consumos || []).forEach((consumo) => {
    const matriz = (orden.matrices || []).find(
      (m) => (m.matrizId?._id || m.matrizId)?.toString() === (consumo.matrizId?._id || consumo.matrizId)?.toString()
    );
    const planeado = consumo.cantidad || 0;
    const real = consumo.consumido || 0;
    filasComparativo.push([
      {
        text: `${nombreInsumo(matriz?.matrizId || matriz)} — ${consumo.etapaId?.nombre || "?"}`,
        style: "textoTabla",
        bold: true,
        colSpan: 5,
      },
      {}, {}, {}, {},
    ]);
    (matriz?.especificaciones || []).forEach((esp) => {
      const insumo = esp.insumoId;
      const planeadoInsumo = (esp.cantidad || 0) * planeado;
      const realInsumo = (esp.cantidad || 0) * real;
      filasComparativo.push([
        { text: `   ${nombreInsumo(insumo)}`, style: "textoTabla" },
        { text: insumo?.unidadId?.nombre || "—", style: "textoTabla", alignment: "center" },
        { text: cantidad4(planeadoInsumo), style: "textoTabla", alignment: "right" },
        { text: cantidad4(realInsumo), style: "textoTabla", alignment: "right" },
        { text: cantidad4(planeadoInsumo - realInsumo), style: "textoTabla", alignment: "right" },
      ]);
    });
  });

  const piezasResueltasAlCierre = orden.piezasResueltasAlCierre || 0;
  const filasUsoReal = (orden.consumoRealAlCierre || []).map((c) => {
    const promedioPorPieza = piezasResueltasAlCierre > 0 ? c.consumoReal / piezasResueltasAlCierre : 0;
    return [
      { text: nombreInsumo(c.insumoId), style: "textoTabla" },
      { text: c.insumoId?.unidadId?.nombre || "—", style: "textoTabla", alignment: "center" },
      { text: cantidad4(c.consumoReal), style: "textoTabla", alignment: "right" },
      { text: cantidad4(promedioPorPieza), style: "textoTabla", alignment: "right" },
    ];
  });

  const generadosPorInsumo = new Map();
  movimientos.forEach((movimiento) => {
    const alta = movimiento.altaInventario;
    if (!alta?.insumoId || !(alta.cantidad > 0)) return;
    const clave = `${(alta.insumoId._id || alta.insumoId).toString()}-${alta.tipo}`;
    const previo = generadosPorInsumo.get(clave) || { insumo: alta.insumoId, tipo: alta.tipo, cantidad: 0, costo: 0 };
    previo.cantidad += alta.cantidad;
    previo.costo += (alta.costoUnitario || 0) * alta.cantidad;
    generadosPorInsumo.set(clave, previo);
  });

  const filasGenerados = [...generadosPorInsumo.values()].map((g) => [
    { text: nombreInsumo(g.insumo), style: "textoTabla" },
    { text: g.insumo?.unidadId?.nombre || "—", style: "textoTabla", alignment: "center" },
    { text: g.tipo === "scrap" ? "Scrap" : "Terminado", style: "textoTabla", alignment: "center" },
    { text: cantidad4(g.cantidad), style: "textoTabla", alignment: "right" },
    { text: dineroDisabledMask(g.costo), style: "textoTabla", alignment: "right" },
  ]);

  const filasMovimientos = movimientos.map((movimiento) => [
    { text: moment(movimiento.fecha).format("DD/MM/YY HH:mm"), style: "textoMuyChico" },
    {
      text:
        movimiento.loteDestinoId && movimiento.loteDestinoId._id !== movimiento.loteOrigenId?._id
          ? `${movimiento.loteOrigenId?.folio} -> ${movimiento.loteDestinoId.folio}`
          : movimiento.loteOrigenId?.folio || "—",
      style: "textoMuyChico",
    },
    { text: `${movimiento.etapaOrigenId?.nombre || "Inicio"} -> ${movimiento.etapaDestinoId?.nombre || "—"}`, style: "textoMuyChico" },
    { text: cantidad4(movimiento.cantidad), style: "textoMuyChico", alignment: "right" },
    { text: dineroDisabledMask(movimiento.costoTotalConsumido || 0), style: "textoMuyChico", alignment: "right" },
    { text: nombreCompleto(movimiento.responsableId), style: "textoMuyChico" },
    { text: movimiento.cancelado ? "Cancelado" : movimiento.esRetrabajo ? "Retrabajo" : "—", style: "textoMuyChico" },
  ]);

  const dd = {
    footer: (currentPage, pageCount) => ({
      text: `${currentPage} / ${pageCount}`,
      alignment: "center",
      style: "textoMuyChico",
      margin: [0, 4, 0, 0],
    }),
    content: [
      {
        style: "tableExample",
        table: {
          widths: ["18%", "52%", "30%"],
          body: [
            [
              { border: [false, false, false, false], image: "logo", fit: [80, 80] },
              {
                border: [false, false, false, false],
                table: {
                  widths: ["100%"],
                  body: [
                    [{ text: empresa.nombre || "-", style: "tableHeader" }],
                    [{ text: `RFC: ${empresa.rfc || "-"}`, style: "textoChico", alignment: "center" }],
                    [{ text: "ORDEN DE PRODUCCIÓN — CIERRE", style: "tableHeader" }],
                  ],
                },
                layout: "noBorders",
              },
              {
                border: [false, false, false, false],
                table: {
                  widths: ["100%"],
                  body: [
                    [{ text: "Folio:", style: "subheader", alignment: "center" }],
                    [{ text: orden.folio || "-", style: "textoChico", alignment: "center" }],
                    [{ text: "Fecha de cierre:", style: "subheader", alignment: "center" }],
                    [
                      {
                        text: orden.fechaTerminada ? moment(orden.fechaTerminada).format("LL") : "-",
                        style: "textoChico",
                        alignment: "center",
                      },
                    ],
                  ],
                },
                layout: "noBorders",
              },
            ],
          ],
        },
      },

      {
        style: "tableExample",
        table: {
          widths: ["25%", "25%", "25%", "25%"],
          body: [
            [
              { text: "Presupuesto:", style: "subheader" },
              { text: orden.presupuestoPUId?.nombre || "—", style: "textoChico" },
              { text: "Partida:", style: "subheader" },
              { text: orden.partidaSnapshot?.nombre || (orden.matrices || []).map((m) => m.clave || m.descripcion).join(", ") || "—", style: "textoChico" },
            ],
            [
              { text: "Proyecto de ejecución:", style: "subheader" },
              { text: orden.proyectoEjecucionId?.nombre || "—", style: "textoChico" },
              { text: "Insumo relacionado:", style: "subheader" },
              { text: nombreInsumo(orden.insumoRelacionadoId), style: "textoChico" },
            ],
            [
              { text: "Cantidad esperada:", style: "subheader" },
              { text: (orden.cantidadEsperada ?? "—").toString(), style: "textoChico" },
              { text: "Costo unitario final:", style: "subheader" },
              { text: dineroDisabledMask(orden.costoUnitarioComponentes || 0), style: "textoChico" },
            ],
            [
              { text: "Terminado por:", style: "subheader" },
              { text: nombreCompleto(orden.terminadoPorId), style: "textoChico" },
              { text: "", style: "subheader" },
              { text: "", style: "textoChico" },
            ],
          ],
        },
        layout: "noBorders",
      },

      { text: "Costo por lote", style: "tituloSeccion", margin: [0, 12, 0, 4] },
      {
        table: {
          widths: ["16%", "10%", "22%", "16%", "16%", "10%", "10%"],
          body: [
            [
              { text: "Lote", style: "tituloTabla" },
              { text: "Piezas", style: "tituloTabla" },
              { text: "Etapa actual", style: "tituloTabla" },
              { text: "Costo unitario", style: "tituloTabla" },
              { text: "Costo total", style: "tituloTabla" },
              { text: "Retrab.", style: "tituloTabla" },
              { text: "Estado", style: "tituloTabla" },
            ],
            ...filasLotes,
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },

      { text: "Plan vs. real por insumo", style: "tituloSeccion", margin: [0, 16, 0, 4] },
      {
        table: {
          widths: ["43%", "14%", "14%", "14%", "15%"],
          body: [
            [
              { text: "Matriz / insumo", style: "tituloTabla" },
              { text: "Unidad", style: "tituloTabla" },
              { text: "Planeado", style: "tituloTabla" },
              { text: "Consumido", style: "tituloTabla" },
              { text: "Diferencia", style: "tituloTabla" },
            ],
            ...filasComparativo,
          ],
        },
        layout: {
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },

      { text: "Uso real promedio por pieza (según cierre)", style: "tituloSeccion", margin: [0, 16, 0, 4] },
      filasUsoReal.length > 0
        ? {
            table: {
              widths: ["44%", "16%", "20%", "20%"],
              body: [
                [
                  { text: "Insumo", style: "tituloTabla" },
                  { text: "Unidad", style: "tituloTabla" },
                  { text: "Consumo real total", style: "tituloTabla" },
                  { text: `Promedio / pieza (${piezasResueltasAlCierre})`, style: "tituloTabla" },
                ],
                ...filasUsoReal,
              ],
            },
            layout: {
              fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          }
        : {
            text: "Esta orden se cerró antes de capturar el sobrante real por insumo.",
            style: "textoChico",
          },

      { text: "Insumos generados por esta orden", style: "tituloSeccion", margin: [0, 16, 0, 4] },
      filasGenerados.length > 0
        ? {
            table: {
              widths: ["44%", "16%", "16%", "12%", "12%"],
              body: [
                [
                  { text: "Insumo", style: "tituloTabla" },
                  { text: "Unidad", style: "tituloTabla" },
                  { text: "Tipo", style: "tituloTabla" },
                  { text: "Cantidad", style: "tituloTabla" },
                  { text: "Costo total", style: "tituloTabla" },
                ],
                ...filasGenerados,
              ],
            },
            layout: {
              fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
              hLineColor: () => "#adaaaa",
              vLineColor: () => "#adaaaa",
            },
          }
        : { text: "Esta orden todavía no ha dado de alta ningún insumo.", style: "textoChico" },

      { text: "Historial de movimientos", style: "tituloSeccion", margin: [0, 16, 0, 4], pageBreak: "before" },
      {
        table: {
          widths: ["10%", "18%", "26%", "8%", "12%", "16%", "10%"],
          body: [
            [
              { text: "Fecha", style: "tituloTabla" },
              { text: "Lote", style: "tituloTabla" },
              { text: "Movimiento", style: "tituloTabla" },
              { text: "Piezas", style: "tituloTabla" },
              { text: "Costo", style: "tituloTabla" },
              { text: "Responsable", style: "tituloTabla" },
              { text: "Nota", style: "tituloTabla" },
            ],
            ...filasMovimientos,
          ],
        },
        layout: {
          fillColor: (rowIndex) => (rowIndex % 2 === 0 ? "#e8e8e8" : "#ffffff"),
          hLineColor: () => "#adaaaa",
          vLineColor: () => "#adaaaa",
        },
      },
    ],
    images: {
      logo: empresa.logo?.base64Completa || "",
    },
    defaultStyle: {
      font: "Roboto",
      fontSize: 9,
    },
    styles: {
      subheader: { fontSize: 8, bold: true },
      tableExample: { margin: [0, 5, 0, 5] },
      tableHeader: { bold: true, fontSize: 12, color: "black", alignment: "center" },
      tituloSeccion: { fontSize: 11, bold: true, color: "#1890ff" },
      textoChico: { fontSize: 8 },
      textoMuyChico: { fontSize: 7 },
      tituloTabla: { fontSize: 7, bold: true, fillColor: "#cccccc", alignment: "center" },
      textoTabla: { fontSize: 8 },
    },
    pageSize: "LETTER",
    pageMargins: [20, 20, 20, 30],
  };

  return dd;
};

export default ordenProduccionCierrePdf;
